class GartnerPi_Scroller {
  constructor(options) {
    Object.assign(this, options)
    this.visibilityThreshold = 0.75 // 75% visibility threshold
    this.init()
  }
  init() {
    this.waitForElement(this.containerSelector).then((element) => {
      this.initScrollWatch(element)
    })
  }
  initScrollWatch(scroller) {
    const units = scroller.querySelectorAll(this.unitSelector)
    const debouncedScrollSweep = this.debounce(() => this.runScrollSweep(scroller, units), 300)
    scroller.addEventListener("scroll", debouncedScrollSweep)
  }
  runScrollSweep(scroller, units) {
    const scrollerRect = scroller.getBoundingClientRect()
    units.forEach((unit) => {
      const unitRect = unit.getBoundingClientRect()
      const visibleWidth = Math.min(unitRect.right, scrollerRect.right) - Math.max(unitRect.left, scrollerRect.left)
      const visibleHeight = Math.min(unitRect.bottom, scrollerRect.bottom) - Math.max(unitRect.top, scrollerRect.top)
      const isVisible =
        visibleWidth >= unitRect.width * this.visibilityThreshold &&
        visibleHeight >= unitRect.height * this.visibilityThreshold
      unit.setAttribute("aria-hidden", !isVisible)
    })
  }
  waitForElement(selector) {
    return new Promise((resolve) => {
      function check() {
        const element = document.querySelector(selector)
        if (element) {
          resolve(element)
        } else {
          requestAnimationFrame(check)
        }
      }
      check()
    })
  }
  debounce(func, wait) {
    let timeout
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }
}

export { GartnerPi_Scroller }
